import { api } from "./client";

export const authApi = {
  register: (payload) => api.post("/auth/register", payload),
  login: (payload) => api.post("/auth/login", payload),
  logout: (refreshToken) => api.post("/auth/logout", { refreshToken }),
  me: () => api.get("/auth/me"),
  forgotPassword: (payload) => api.post("/auth/forgot-password", payload),
  resetPassword: (payload) => api.post("/auth/reset-password", payload),
};

export const catalogApi = {
  getCategories: () => api.get("/categories"),
  getProducts: (params) => api.get("/products", { params }),
  getProduct: (idOrSlug) => api.get(`/products/${idOrSlug}`),
  createProduct: (payload) => api.post("/products", payload),
  updateProduct: (id, payload) => api.patch(`/products/${id}`, payload),
  deleteProduct: (id) => api.delete(`/products/${id}`),
  restoreProduct: (id) => api.post(`/products/${id}/restore`),
  adminProducts: (params) => api.get("/admin/products", { params }),
  adminProductStats: () => api.get("/admin/products/stats"),
  createCategory: (payload) => api.post("/categories", payload),
  updateCategory: (id, payload) => api.patch(`/categories/${id}`, payload),
  deleteCategory: (id) => api.delete(`/categories/${id}`),
  adminCategories: () => api.get("/admin/categories"),
  createReview: (idOrSlug, payload) =>
    api.post(`/products/${idOrSlug}/reviews`, payload),
  adminReviews: () => api.get("/admin/reviews"),
  updateReview: (id, payload) => api.patch(`/admin/reviews/${id}`, payload),
  deleteReview: (id) => api.delete(`/admin/reviews/${id}`),
  uploadImages: (files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append("images", file));
    return api.post("/uploads/products", formData);
  },
  deleteUploadedImage: (url) => api.delete("/uploads/products", { data: { url } }),
};

export const cartApi = {
  get: () => api.get("/cart"),
  add: (productId, quantity = 1, extras = {}) =>
    api.post("/cart/items", { productId, quantity, ...extras }),
  update: (itemId, quantity) => api.patch(`/cart/items/${itemId}`, { quantity }),
  remove: (itemId) => api.delete(`/cart/items/${itemId}`),
  clear: () => api.delete("/cart"),
};

export const wishlistApi = {
  get: () => api.get("/wishlist"),
  add: (productId) => api.post("/wishlist/items", { productId }),
  remove: (productId) => api.delete(`/wishlist/items/${productId}`),
  moveToCart: (productId) =>
    api.post(`/wishlist/items/${productId}/move-to-cart`),
};

export const ordersApi = {
  checkout: (payload = {}) => api.post("/orders/checkout", payload),
  mine: () => api.get("/orders/me"),
  track: (params) => api.get("/orders/track", { params }),
};

export const quotesApi = {
  create: (payload) => api.post("/quotes", payload),
  mine: () => api.get("/quotes/me"),
};

export const contactApi = {
  create: (payload) => api.post("/contact", payload),
};

export const homeContentApi = {
  get: () => api.get("/home"),
  update: (payload) => api.patch("/admin/home", payload),
  uploadImages: (files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append("images", file));
    return api.post("/uploads/home", formData);
  },
  deleteImage: (url) => api.delete("/uploads/home", { data: { url } }),
};

export const signContentApi = {
  get: () => api.get("/sign"),
  update: (payload) => api.patch("/admin/sign", payload),
  uploadImages: (files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append("images", file));
    return api.post("/uploads/sign", formData);
  },
  deleteImage: (url) => api.delete("/uploads/sign", { data: { url } }),
};

export const catalogueContentApi = {
  get: () => api.get("/catalogue"),
  update: (payload) => api.patch("/admin/catalogue", payload),
  uploadImages: (files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append("images", file));
    return api.post("/uploads/catalogue/images", formData);
  },
  uploadFiles: (files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));
    return api.post("/uploads/catalogue/files", formData, {
      timeout: 5 * 60 * 1000,
    });
  },
  deleteFile: (url) => api.delete("/uploads/catalogue", { data: { url } }),
};

/** Sales + admin management endpoints */
export const adminApi = {
  orders: () => api.get("/orders"),
  updateOrderStatus: (id, status) => api.patch(`/orders/${id}/status`, { status }),
  quotes: () => api.get("/quotes"),
  updateQuote: (id, payload) => api.patch(`/quotes/${id}`, payload),
  enquiries: () => api.get("/contact"),
  updateEnquiry: (id, payload) => api.patch(`/contact/${id}`, payload),
  users: () => api.get("/auth/users"),
  createUser: (payload) => api.post("/auth/users", payload),
  updateUser: (id, payload) => api.patch(`/auth/users/${id}`, payload),
};

export const settingsApi = {
  getEmail: () => api.get("/admin/settings/email"),
  updateEmail: (payload) => api.patch("/admin/settings/email", payload),
  sendTestEmail: (to) => api.post("/admin/settings/email/test", { to }),
};

export const assistantApi = {
  chat: (payload) => api.post("/assistant/chat", payload),
};
